var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoowearImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 136,
    viewBox: "0 0 155 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8642 135.639L106.505 92.0424L63.6292 57.3394L0.5 93.275L42.8642 135.639Z",
    fill: "#A5AFD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.5 0.360352V131L13.5 17.4998V0.360352H154.5Z",
    fill: "#E4E6EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8203 17.0186L106.509 92.0425L153.5 130.074",
    fill: "#2B3C97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8203 17.0186L106.509 92.0425L153.5 130.074",
    stroke: "#2B3C97",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoowearImage1);
export default __webpack_public_path__ + "static/media/Foowear_image_1.024d042275409b8c3366e10dac943fc5.svg";
export { ForwardRef as ReactComponent };